var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-group"},_vm._l((_vm.list),function(todo,index){return _c('div',{key:index,staticClass:"list-group-item"},[_c('i',{staticClass:"fa btn btn-sm",class:{'fa-check-square':todo.doneIt, 'fa-square':!todo.doneIt},on:{"click":function($event){todo.doneIt = !todo.doneIt}}}),_vm._v(" "+_vm._s(todo.text)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }